import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import ConfirmationModalNew from "../../../../common/ConfirmationModalNew";
import SpecialPopulations from "./special-populations";
import { ClinicalServiceTypes } from "../../../text/data";
import { updateClinicalService } from "../../../../../redux/modules/clinical-services/actions";
import Button from "../../../../common/Button";
import ChartNav from "../../../../common/ChartNav";
import SubNavigation from "../../common/sub-navigation";

/**
 * Shows the "previous diagnosis" question after consent and before Special Populations
 * when required for a service. Currently implements Allergic Rhinitis; extend with
 * additional service checks as other minor ailments use this gate.
 */
const PreviousHistoryGate = () => {
  const { clinicalServiceName, clinicalServiceObj } = useSelector(
    (state) => state.clinicalService
  );
  const { serviceId } = useParams();
  const dispatch = useDispatch();

  const pre =
    clinicalServiceObj?.initialAssessment?.initialAssessmentForm?.preAssessment;

  const isAllergicRhinitis =
    clinicalServiceName === ClinicalServiceTypes.AllergicRhinitis ||
    clinicalServiceName === "AllergicRhinitis";

  const [answeredLocally, setAnsweredLocally] = useState(false);

  const serverAnswered = typeof pre?.previousHistoryIndicator === "boolean";
  const showPreviousHistoryModal =
    isAllergicRhinitis && !serverAnswered && !answeredLocally;

  const persistPreviousHistory = (hasHistory) => {
    setAnsweredLocally(true);
    dispatch(
      updateClinicalService(serviceId, {
        preAssessment: {
          ...pre,
          previousHistoryIndicator: hasHistory,
        },
      })
    );
  };

  const ExtraButtonComponent = () => (
    <Button
      className="min-w-fit"
      type="primary-outline"
      text="Not sure"
      onClick={() => persistPreviousHistory(false)}
    />
  );

  if (!isAllergicRhinitis) {
    return <SpecialPopulations />;
  }

  return (
    <>
      {showPreviousHistoryModal ? (
        <div className="flex flex-col flex-1 gap-4 bg-white">
          <div className="flex flex-1 gap-4">
            <ChartNav />
            <div className="flex flex-1 w-full h-full">
              <div className="w-full h-full">
                <div className="flex items-center justify-end mt-0.5 mb-0.5">
                  <SubNavigation />
                </div>
                <div className="border-b-[7px] border-gray-20 mb-[20px]" />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <SpecialPopulations />
      )}
      <ConfirmationModalNew
        open={showPreviousHistoryModal}
        title="Previous History of Allergic Rhinitis"
        type="primary-outline"
        confirmText="No"
        cancelText="Yes"
        className="!w-[436px] !max-w-none list-disc !bg-white"
        content={() => (
          <p>
            Have you had a recent or previous diagnosis of Allergic Rhinitis?
          </p>
        )}
        handleClose={() => persistPreviousHistory(true)}
        onCross={() => {}}
        hideCloseIcon
        maskClosable={false}
        confirmAction={() => persistPreviousHistory(false)}
        cancelAction={() => persistPreviousHistory(true)}
        cancelBtnType="primary-outline"
        verticalButtons
        extraButtonComponent={() => <ExtraButtonComponent />}
      />
    </>
  );
};

export default PreviousHistoryGate;
